"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PalletEstimatorClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const defaultPalletEstimatorClientConfig = {
    serviceUrl: process.env.PALLET_ESTIMATOR_SERVICE_URL,
    basicAuthUser: process.env.PALLET_ESTIMATOR_BASIC_AUTH_USER,
    basicAuthPassword: process.env.PALLET_ESTIMATOR_BASIC_AUTH_PASSWORD,
};
class PalletEstimatorClient extends base_client_1.ApiBasicAuthClient {
    constructor(palletEstimatorClientConfig = defaultPalletEstimatorClientConfig, axiosConfig = {}) {
        const { serviceUrl, basicAuthUser, basicAuthPassword } = palletEstimatorClientConfig;
        if (!serviceUrl) {
            throw new Error("PALLET_ESTIMATOR_SERVICE_URL environment variable is not set");
        }
        const baseUrl = `${serviceUrl}/pallet-estimation`;
        super(Object.assign(Object.assign({}, axiosConfig), { baseURL: baseUrl, basicAuthUser,
            basicAuthPassword }));
        this.baseUrl = baseUrl;
        if (!basicAuthUser) {
            commons_logs_1.log.warn("The PALLET_ESTIMATOR_BASIC_AUTH_USER environment variable was not set.");
        }
        else if (!basicAuthPassword) {
            commons_logs_1.log.warn("The PALLET_ESTIMATOR_BASIC_AUTH_PASSWORD environment variable was not set.");
        }
    }
    async generatePalletEstimation(palletEstimatorRequest) {
        commons_logs_1.log.info(`palletEstimatorRequest:`, palletEstimatorRequest);
        try {
            return await this.post(`${this.baseUrl}/v1`, palletEstimatorRequest);
        }
        catch (ex) {
            throw this.maybeGetNetworkError(ex);
        }
    }
    async getPalletEstimationByOperationId(operationId) {
        commons_logs_1.log.info(`operationId:`, operationId);
        try {
            return await this.get(`${this.baseUrl}/v1/${operationId}`);
        }
        catch (ex) {
            throw this.maybeGetNetworkError(ex);
        }
    }
    async generatePalletEstimationV2(palletEstimatorRequest) {
        commons_logs_1.log.info(`palletEstimatorRequest:`, palletEstimatorRequest);
        try {
            return await this.post(`${this.baseUrl}/v1`, palletEstimatorRequest);
        }
        catch (ex) {
            throw this.maybeGetNetworkError(ex);
        }
    }
}
exports.PalletEstimatorClient = PalletEstimatorClient;
//# sourceMappingURL=PalletEstimatorClient.js.map